var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'core', 'model/base', 'common/location'], function($, _, core, BaseModel, location) {
  var CategorizerRule;
  return CategorizerRule = (function(_super) {

    __extends(CategorizerRule, _super);

    function CategorizerRule() {
      CategorizerRule.__super__.constructor.apply(this, arguments);
    }

    CategorizerRule.prototype.pathRoot = location.categorizerApiPath + 'clientrules';

    CategorizerRule.prototype.defaults = function() {
      return {
        id: null,
        clientId: null,
        ledgerId: null,
        priority: null,
        vendorContains: null,
        minAmount: null,
        maxAmount: null
      };
    };

    CategorizerRule.prototype.sync = function(method, model, options) {
      return CategorizerRule.__super__.sync.call(this, method, model, options);
    };

    CategorizerRule.prototype.validate = function() {
      var clientId, ledgerId, maxAmount, minAmount, priority, vendorContains;
      clientId = this.get('clientId');
      ledgerId = this.get('ledgerId');
      priority = this.get('priority');
      vendorContains = this.get('vendorContains');
      minAmount = this.get('minAmount');
      maxAmount = this.get('maxAmount');
      if (clientId === void 0 || _.isNaN(clientId)) {
        return 'Client must not be unset';
      } else if (ledgerId === void 0 || _.isNaN(ledgerId)) {
        return 'Ledger must not be unset';
      } else if (priority === void 0 || _.isNaN(priority) || priority <= 0) {
        return 'Priority must be valid';
      } else if (vendorContains === null || _.isEmpty(vendorContains)) {
        return 'Must have a vendor keyword';
      } else if ((minAmount != null) && _.isNaN(Number(minAmount))) {
        return 'Min amount must be valid';
      } else if ((maxAmount != null) && _.isNaN(Number(maxAmount))) {
        return 'Max amount must be valid';
      } else if ((minAmount != null) && (maxAmount != null) && Number(minAmount) > Number(maxAmount)) {
        return 'Min amount must be less than max amount';
      }
    };

    return CategorizerRule;

  })(BaseModel);
});
